import { Right } from './Rights.enum';

export class CdkTableColumns {
    title: string;
    responsiveTitle?: string;
    name: string;
    sort: boolean | string = false;
    typeColumn: CdkTableTypeColumn = CdkTableTypeColumn.html;
    messageTooltip?: string = null;
    placementTooltip?: string = 'top';
    enabledTooltip?: boolean = true;
    parentTooltip?: boolean = true;
    showColumn?: string = null;
    readOnly?: boolean = null;
    requireReadRight?: Right = null;
}

export enum CdkTableTypeColumn {
    html,
    date,
    imageLink,
    rowImage,
    money
}
